var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_22913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14489 1.92998L0.909888 8.99998C0.822572 9.15119 0.776372 9.32263 0.775883 9.49724C0.775394 9.67185 0.820634 9.84355 0.907102 9.99524C0.993569 10.1469 1.11825 10.2734 1.26874 10.3619C1.41923 10.4505 1.59029 10.4981 1.76489 10.5H10.2349C10.4095 10.4981 10.5805 10.4505 10.731 10.3619C10.8815 10.2734 11.0062 10.1469 11.0927 9.99524C11.1791 9.84355 11.2244 9.67185 11.2239 9.49724C11.2234 9.32263 11.1772 9.15119 11.0899 8.99998L6.85489 1.92998C6.76575 1.78303 6.64025 1.66154 6.49049 1.57722C6.34072 1.4929 6.17176 1.44861 5.99989 1.44861C5.82802 1.44861 5.65905 1.4929 5.50929 1.57722C5.35953 1.66154 5.23402 1.78303 5.14489 1.92998V1.92998Z",
    stroke: "#B4000F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5V6.5",
    stroke: "#B4000F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5H6.005",
    stroke: "#B4000F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_22913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ad8192b9cfcaaa1c89eea7217b18d429.svg";
export { ForwardRef as ReactComponent };